/** @file Utilities for working with sanctuary compatible types */

type Unsafe<T> = T|Error & {'@@type': 'Error'}

// TODO: tests for matchError
export function matchError<T, R>(whenError: (_: Error) => R,
                                 whenElse: (_: T) => R,
                                 a: Unsafe<T>): R {
  if ((a as {'@@type': 'Error'})['@@type'] === 'Error') {
    return whenError(a as Error)
  } else {
    return whenElse(a as T);
  }
}
